var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chart-icon",
    transform: "translate(-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8528",
    "data-name": "Path 8528",
    d: "M10,51h.923v1.92H10Z",
    transform: "translate(-2.154 -29.88)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8529",
    "data-name": "Path 8529",
    d: "M24,41h.923v6.72H24Z",
    transform: "translate(-9.692 -24.68)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8530",
    "data-name": "Path 8530",
    d: "M38,49h.923v2.88H38Z",
    transform: "translate(-17.231 -28.84)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8531",
    "data-name": "Path 8531",
    d: "M52,33h.923V43.56H52Z",
    transform: "translate(-24.769 -20.52)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8532",
    "data-name": "Path 8532",
    d: "M24.192,16.5a.721.721,0,1,0,.692.72A.707.707,0,0,0,24.192,16.5Z",
    transform: "translate(-9.423 -11.94)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8533",
    "data-name": "Path 8533",
    d: "M52.192,10.5a.721.721,0,1,0,.692.72A.707.707,0,0,0,52.192,10.5Z",
    transform: "translate(-24.5 -8.82)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8534",
    "data-name": "Path 8534",
    d: "M9.692,43H6.923A.943.943,0,0,0,6,43.96v5.76h4.615V43.96A.943.943,0,0,0,9.692,43Zm0,.96v.96H6.923v-.96Zm-2.769,4.8V45.88H9.692v2.88Z",
    transform: "translate(0 -25.72)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8535",
    "data-name": "Path 8535",
    d: "M23.692,33H20.923a.943.943,0,0,0-.923.96V44.52h4.615V33.96A.943.943,0,0,0,23.692,33Zm0,.96v.96H20.923v-.96Zm-2.769,9.6V35.88h2.769v7.68Z",
    transform: "translate(-7.538 -20.52)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8536",
    "data-name": "Path 8536",
    d: "M37.692,41H34.923a.943.943,0,0,0-.923.96v6.72h4.615V41.96A.943.943,0,0,0,37.692,41Zm0,.96v.96H34.923v-.96Zm-2.769,5.76V43.88h2.769v3.84Z",
    transform: "translate(-15.077 -24.68)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8537",
    "data-name": "Path 8537",
    d: "M51.692,25H48.923a.943.943,0,0,0-.923.96v14.4h4.615V25.96A.943.943,0,0,0,51.692,25Zm0,.96v.96H48.923v-.96ZM48.923,39.4V27.88h2.769V39.4Z",
    transform: "translate(-22.615 -16.36)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8538",
    "data-name": "Path 8538",
    d: "M26.791,11.609a2.215,2.215,0,0,0,.9.191,2.4,2.4,0,1,0-2.308-2.4,2.439,2.439,0,0,0,.648,1.661l-3.574,4.956a2.193,2.193,0,0,0-2.677.171l-3.074-2.616a2.448,2.448,0,0,0,.369-1.292,2.309,2.309,0,1,0-4.615,0,2.447,2.447,0,0,0,.281,1.123L9.705,16.144a2.23,2.23,0,0,0-1.4-.5,2.4,2.4,0,0,0,0,4.8,2.358,2.358,0,0,0,2.308-2.4,2.442,2.442,0,0,0-.306-1.171l3.022-2.727a2.207,2.207,0,0,0,2.734.123L19.2,16.93a2.441,2.441,0,0,0-.274,1.11,2.309,2.309,0,1,0,4.615,0,2.449,2.449,0,0,0-.407-1.356Zm.9-3.649A1.441,1.441,0,1,1,26.308,9.4,1.415,1.415,0,0,1,27.692,7.96ZM8.308,19.48a1.441,1.441,0,1,1,1.385-1.44A1.415,1.415,0,0,1,8.308,19.48Zm6.462-5.76a1.441,1.441,0,1,1,1.385-1.44A1.415,1.415,0,0,1,14.769,13.72Zm6.462,5.76a1.441,1.441,0,1,1,1.385-1.44A1.415,1.415,0,0,1,21.231,19.48Z",
    transform: "translate(0 -7)",
    fill: "#325ae7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart-icon.80df7314d4f57a4579241d39a1888d4d.svg";
export { ForwardRef as ReactComponent };